import React, {useState, useEffect} from "react";
import t from '../../../helpers/t';
import {
    useSelector,
    locationActions,
    checkinActions,
    resourcesActions,
    pricesActions,
    reservationsActions
} from "inbooma-api";
import {Biscuit, FormatHelper, Notification} from "../../../../utils";
import {$, _, Backbone, moment} from "../../../../../vendor";
import {getClientTariffs} from "../../../../App";
import CheckInItem from "./CheckInItem";
import CheckOutItem from "./CheckOutItem";
import contingents from "inbooma-api/store/contingents";

const CheckOutView = (props) =>
{
    const [reservation,setReservation] = useState(props.reservation);
    const [reservationReady,setReservationReady] = useState(false);
    const [reservationPending,setReservationPending] = useState(false);
    const [resourceReady,setResourceReady] = useState(false);
    const [_checkinReady,setCheckinReady] = useState(false);
    const [locationsPending,setLocationsPending] = useState(false);
    const [contingentPending,setContingentPending] = useState(false);
    const [resourcesPending,setResourcesPending] = useState(false);
    const [resourcePending,setResourcePending] = useState(false);
    const [pricePending,setPricePending] = useState(false);
    const [checkinPending,setCheckinPending] = useState(false);
    const [locations,setLocations] = useState([]);
    const [contingent,setContingent] = useState([]);
    const [requiredContingentsWithAmount,setRequiredContingentsWithAmount] = useState({});
    const [resourceIdsByContingent, setResourceIdsByContingent] = useState({});
    const [resources,setResources] = useState([]);
    const [resource,setResource] = useState([]);
    const [price,setPrice] = useState({});
    const _locations = useSelector(state => state.locations_data.locations);
    const _resources = useSelector(state => state.resources_data.getResources);
    const _resource = useSelector(state => state.resources_data.getResource);
    const _reservation = useSelector(state => state.reservations.patchReservations);
    const _price = useSelector(state => state.prices_data.calculatePrice);
    const _submitCheckin = useSelector(state => state.checkins.checkins);
    const [ready,setReady] = useState(false);
    const [isStepCheckout, setIsStepCheckout] = useState((props.reservation.checkins.length > 0));
    const [selectedResources, setSelectedResources] = useState(null);
    const [_checkin, _setCheckin] = useState(null);
    const [selectionIsComplete,setSelectionIsComplete] = useState(false);
    const [date,setDate] = useState(new Date());
    const [multi, setMulti] = useState(true);
    const [counted,setCounted] = useState(0);
    const [multipleCheckins, setMultipleCheckins] = useState(reservation.checkins.length > 1 && (typeof props.checkin === undefined || props.checkin === null));
    const [forCheckoutExtended, setForCheckoutExtended] = useState(true);
    const checkoutComplete = ((reservation.checkins.length > 0 && typeof reservation.checkins[0] !== 'undefined' && typeof reservation.checkins[0].checkout !== 'undefined' && reservation.checkins[0].checkout !== null && reservation.checkins.length < 2) || (typeof props.checkin !== 'undefined' && props.checkin !== null && props.checkin.checkout !== null));

    const [checkIn,setCheckIn] = useState(typeof props.checkin !== undefined && props.checkin !== null?props.checkin:(typeof reservation.checkins !== "undefined" && reservation.checkins.length > 0)?reservation.checkins[0]:
        {
            resource_id: null,
            reservation_id: reservation.id,
            location_checkin: reservation.begin_location,
            status: reservation.status,
            checkin: null,
            checkout: null,
            location_checkout: null,
            comment_checkin: null,
            comment_checkout: null,
            location_checkin_name: null,
            location_checkout_name: null,
            resource: {}
        });
    const [locationCheckout, setLocationCheckout] = useState(checkIn.location_checkout);
    const [checkIns,setCheckIns] = useState((multipleCheckins)?reservation.checkins:null);
    const defaultEmptyResource = {
        comment_checkin : '',
        comment_checkout : ''
    };


    const setResourceIdWithAmounts = () =>
    {
        let clone = {...resourceIdsByContingent};
        if (isStepCheckout) {
            /*if (multipleCheckins) {
                checkIns.map(checkin => {
                    clone = _mapResourcesWithAmounts(checkin,clone);
                })
            } else {*/
            clone = _mapResourcesWithAmounts(checkIn,clone);
            // }
        }
        setResourceIdsByContingent(clone);
    }

    const _mapResourcesWithAmounts = (checkin, clone) => {
        // Map reservation.checkins into resourceIdsByContingent

        if (typeof clone[checkin.resource.contingent_id] === 'undefined') {
            clone[checkin.resource.contingent_id] = {};
        }

        if(checkin.location_checkin !== null && checkin.location_checkin_name === null){
            locations.map(location => {
                if(location.id === checkin.location_checkin){
                    checkin.location_checkin_name = location.name;
                }
            })
        }
        if(checkin.location_checkout !== null && checkin.location_checkout_name === null){
            locations.map(location => {
                if(location.id === checkin.location_checkout){
                    checkin.location_checkout_name = location.name;
                }
            })
        }
        const isCheckedOut = typeof checkin.checkout !== 'undefined' && checkin.checkout !== null;

        clone[checkin.resource.contingent_id][checkin.resource_id] = _.clone(defaultEmptyResource);
        clone[checkin.resource.contingent_id][checkIn.resource_id]['created'] = checkIn.created;
        clone[checkin.resource.contingent_id][checkIn.resource_id]['checkin'] = checkIn.checkin;
        clone[checkin.resource.contingent_id][checkin.resource_id]['created_by'] = checkin.created_by;
        clone[checkin.resource.contingent_id][checkin.resource_id]['created_by_name'] = checkin.created_by_name;
        clone[checkin.resource.contingent_id][checkin.resource_id]['modified'] = checkin.modified;
        clone[checkin.resource.contingent_id][checkin.resource_id]['modified_by'] = checkin.modified_by;
        clone[checkin.resource.contingent_id][checkin.resource_id]['modified_by_name'] = checkin.modified_by_name;
        clone[checkin.resource.contingent_id][checkin.resource_id]['location_checkin'] = checkin.location_checkin;
        clone[checkin.resource.contingent_id][checkin.resource_id]['location_checkout'] = checkin.location_checkout;
        clone[checkin.resource.contingent_id][checkin.resource_id]['location_checkin_name'] = checkin.location_checkin_name;
        clone[checkin.resource.contingent_id][checkin.resource_id]['location_checkout_name'] = checkin.location_checkout_name;
        clone[checkin.resource.contingent_id][checkin.resource_id]['comment_checkin'] = checkin.comment_checkin;
        clone[checkin.resource.contingent_id][checkin.resource_id]['checkin_id'] = checkin.id;
        clone[checkin.resource.contingent_id][checkin.resource_id]['checkout'] = checkin.checkout;
        clone[checkin.resource.contingent_id][checkin.resource_id]['resource_id'] = checkin.resource_id;
        // If checkout was already done for this resource, show it as disabled
        clone[checkin.resource.contingent_id][checkin.resource_id]['is_checked_out'] = isCheckedOut;
        clone[checkin.resource.contingent_id][checkin.resource_id]['comment_checkout'] = isCheckedOut ? checkin.comment_checkout : '';

        clone[checkin.resource.contingent_id][checkin.resource_id]['longitude'] = checkin.resource.longitude;                 // value usualy set by app
        clone[checkin.resource.contingent_id][checkin.resource_id]['latitude'] = checkin.resource.latitude;
        clone[checkin.resource.contingent_id][checkin.resource_id]['skipFacilitySlotCheck'] = true;
        return clone;
    }

    const setRequiredContingentsWithAmounts = () => {
        let clone = {...requiredContingentsWithAmount};
        let firstAvailContingent = null;
        let counter = 0;
        _.each(reservation.contingents_reservations, contingent => {
            if(counter < 1){
                firstAvailContingent = contingent.contingent_id;
                counter++;
            }
            clone[contingent.contingent_id] = {
                id: contingent.contingent_id,
                comment_checkout: checkIn?.comment_checkout,
                comment_checkin: checkIn?.comment_checkin,
                total: contingent.amount,
                selectedResources: {}
            }
            if (typeof resourceIdsByContingent[contingent.contingent_id] !== 'undefined') {
                // Is checkout step -> overwrite resource data in order to show
                // previous (checkin-)comment and checkin-id (required for checkout endpoint call)
                Object.values(resourceIdsByContingent[contingent.contingent_id]).map(resource => {
                    clone[contingent.contingent_id].selectedResources[resource.resource_id] = resource;
                })
            }

        });

        if(firstAvailContingent !== null) {
            if(typeof resource.contingent_id !== 'undefined') {
                firstAvailContingent = resource.contingent_id;
            }
            _setCheckin(clone[firstAvailContingent]);
        }
        let temp = {...reservation};
        _.each(clone, (val, id) => {
            // Set internal contingent type with selected- and amount-state
            temp._checkin = val;
        });
        setReservation(temp);
        setRequiredContingentsWithAmount(clone);
    }

    const getCheckoutPrice = (first = false) =>
    {
        let _checkoutTime = moment(date).format('YYYY-MM-DD HH:mm:00');
        if(!first && document.getElementById('inb-hidden-checkout-date') !== null) {
            _checkoutTime = document.getElementById('inb-hidden-checkout-date').value;
        }
        let contingents = {};
        reservation.contingents_reservations.map(cr => {
            contingents[cr.contingent_id] =[{
                amount: cr.amount,
                pricetariff_id: cr.pricetariff_id,
                rab_parent_id: null,
                voucher_id: cr.voucher_id
            }];
        });
        let products = {};
        let voucher_id = null;
        if(typeof reservation.order.order_item_prices !== 'undefined'){
            reservation.order.order_item_prices.map(pr => {
               if(pr.product_id !== null && pr.product_id !== ''){
                   products[pr.product_id] = [{
                       amount: pr.amount,
                       pricetariff_id: pr.pricetariff_id,
                       product_id: pr.product_id
                   }];
               }
               if(pr.voucher_id !== null && pr.voucher_id !== '' && pr.contingent_id == null){
                   voucher_id = pr.voucher_id;
               }
            });
        }


        props.dispatch(pricesActions.calculatePrice({
            begin: moment(reservation.begin).format('YYYY-MM-DD HH:mm:00'),
            end: _checkoutTime,
            /* contingent_id: reservation.contingents_reservations[0].contingent_id,
             count_of_contingents: 1,
             pricetariff_id: reservation.contingents_reservations[0].pricetariff_id,*/
            user_id: Biscuit.get('user.id'),
            Contingents: contingents,
            Products: products,
            voucher_id: voucher_id,
            for_checkout_extended: forCheckoutExtended,
            order_id: reservation.order_id
        }));
        setPricePending(true);
    };


    useEffect(() => {

        if (_.isEmpty(resourceIdsByContingent) && isStepCheckout) return;
        let counter = 0;
        _.each(resourceIdsByContingent,function(value){
            _.each(value,function(val) {
                counter++;
            });
        });
        //if(counter < props.reservation.checkins.length) return;
        setRequiredContingentsWithAmounts();
    },[resourceIdsByContingent]);


    useEffect(() => {

        if (_locations.success === "") return;

        if (_locations.success === true) {
            setLocations([..._locations.data]);
        } else if (_locations.success === false) {
            console.log("Failed to request locations!");
        }
        setLocationsPending(false);
        if(!resourcePending && !resourcesPending && reservationReady && _checkinReady && !pricePending) {
            setReady(true);
        }
    },[_locations]);

    useEffect(() =>{
        if(_reservation.success === "" || !reservationPending) return;
        setReservationPending(false);
        if(_reservation.success === true){
            new Notification({
                message : t('order_cancelled_success'),
                duration : 5000,
                type : 'success',
                closeable : true,
                icon : 'fi fi-mail'
            });
            props.setFilter(props.filter);
            props.setSort(props.sort);
            props.setNKey(props._key);
            props.filterChangedHandle(props.filter);
            if(props.returnUrl !== null && props.returnUrl !== undefined) {
                window.location.href = props.returnUrl;
            }
            props.setCheckout(false);
        } else {
            new Notification({
                message : t('order_cancelled_error') + " "+ (typeof _reservation.data.message !== 'undefined'?_reservation.data.message:""),
                duration : 5000,
                type : 'error',
                closeable : true,
                icon : 'fi fi-mail'
            });
        }
    },[_reservation])

    /*   useEffect(() => {

           if (_contingent.success === "") return;

           if (_contingent.success === true) {
               setContingent([..._contingent.data]);

               let filter = {contingent_id:contingent.id};
               if (isStepCheckout) {
                   filter = {find:"!CheckedIn",contingent_id:contingent.id};
                }
               props.dispatch(resourcesActions.getResources({
                   token: Biscuit.get('token'),
                   filter: filter,
               }));
               setWholeResourcesPending(true);


           } else if (_contingent.success === false) {
               console.log("Failed to request contingent!");
           }
           setContingentPending(false);
           if(!locationsPending && !resourcePending && reservationReady){
               setReady(true);}
       },[_contingent]);*/

    useEffect(() => {

        if (_resources.success === "") return;

        if (_resources.success === true) {
            setResources([..._resources.data]);
        } else if (_resources.success === false) {
            console.log("Failed to request resources!");
        }
        setResourcesPending(false);
        if(!locationsPending && !contingentPending && !resourcePending && reservationReady && _checkinReady && !pricePending && !checkinPending){
            setReady(true);}
    },[_resources]);

    useEffect(() => {

        if (_resource.success === "") return;

        if (_resource.success === true) {
            setResource(_resource.data);
            if(reservation.contingents.length > 0) {
                reservation.contingents.map(c => {
                    if(c.id === _resource.data.contingent_id){
                        setContingent(c);
                    }
                });
            }

            if(!multipleCheckins) {
                let clone = {...checkIn};
                clone.resource = _resource.data;
                setCheckIn(clone);
            } else {
                let clone = {...checkIns};
                _.each(clone,function(cl) {
                    if(cl.resource_id === _resource.data.id) {
                        cl.resource = _resource.data;
                    }
                });
                setCheckIns(clone);
            }
        } else if (_resource.success === false) {
            console.log("Failed to request resource!");
        }
        setResourcesPending(false);
        setResourcePending(false);
        if(!locationsPending && !resourcesPending && reservationReady && _checkinReady && !pricePending && !checkinPending){
            setReady(true);}
    },[_resource]);


    useEffect(() => {
        if((typeof checkIn.resource === 'undefined' || checkIn.resource === {}) && checkIn.resource_id !== null || locationsPending) return;
        setResourceIdWithAmounts();
        setResourceReady(true);
    },[checkIn]);

    useEffect(() => {

        if (_price.success === "" || !pricePending) return;

        if (_price.success === true) {
            setPrice(_price.data.price);
            var clientTariffs = getClientTariffs();
            let temp = document.getElementById('inb-hidden-checkout-date');
            let _checkoutTime = moment(date).format('YYYY-MM-DD HH:mm:00');
            if (typeof temp !== undefined && temp !== null) {
                _checkoutTime = temp.value;
            }
            for (var i=0;i<clientTariffs.length;i++) {
                if (clientTariffs[i].id === reservation.contingents_reservations[0].pricetariff_id) {
                    // proof of extension settings produce further costs
                    if (clientTariffs[i].extension === 'extend_charge') {
                        let extraCost = typeof reservation.price !== 'undefined' ? Number(_price.data.price.price) - Number(reservation.price) : null;
                        if (moment(reservation.end).isBefore((_checkoutTime)) && extraCost !== null && extraCost > 0) {
                            document.getElementById("inb-checkout-extension-hint").classList.remove('hide');
                            document.getElementById("inb-checkout-extra-value").parentNode.classList.remove('hide');
                            //let extraCost = typeof reservation.price !== 'undefined' ? extraCost : null;
                            document.getElementById("inb-checkout-extra-value").innerHTML = extraCost !== null ? FormatHelper.currencyFormat(extraCost) + ' ' + Biscuit.get('client.currency') : '';
                        } else {
                            document.getElementById("inb-checkout-extension-hint").classList.add('hide');
                            document.getElementById("inb-checkout-extra-value").parentNode.classList.add('hide');
                            document.getElementById("inb-checkout-extra-value").innerHTML = '';
                        }
                    }
                }
            }

            const el = document.getElementById("inb-checkout-price-value");
            if (typeof el !== undefined && el !== null) {
                el.innerHTML = FormatHelper.currencyFormat(_price.data.price.price) + " " + Biscuit.get('client.currency');
            }
        } else if (_price.success === false) {
            console.log("Failed to request price!");
            console.log(_price.data)
        }
        setPricePending(false);
        if(!locationsPending && !contingentPending && !resourcesPending && !resourcePending && _checkinReady && !pricePending && !checkinPending){
            setReady(true);}
    },[_price]);



    const isCartView = false;
    useEffect(() => {
        if (typeof reservation._checkin === 'undefined' && typeof reservation.checkins[0] !== 'undefined') return;

        if (typeof reservation.checkins[0] === 'undefined'){if(!locationsPending && !resourcePending && !resourcesPending && _checkinReady && !pricePending && !checkinPending){
            setReady(true);} }
        if(typeof reservation._checkin !== 'undefined') {
            setReservationReady(true);
            setSelectedResources(reservation._checkin.selectedResources);
        }
        if(!locationsPending && !resourcePending && !resourcesPending && _checkinReady ){
            setReady(true);}
    },[reservation]);

    useEffect(() => {
        if (_checkin === null && typeof reservation.checkins[0] !== 'undefined') return;
        if (_checkin === null && typeof reservation.checkins[0] === 'undefined' && !locationsPending && !resourcePending && reservationReady && !pricePending){
            setReady(true);
            return;
        }
        if(_checkin !== null) {
            setSelectionIsComplete((_checkin.total <= _.size(_checkin.selectedResources)));
            setCheckinReady(true);
            if(!checkoutComplete) {
                getCheckoutPrice(true);
            }
            if (!locationsPending && !resourcePending && !resourcesPending && reservationReady && !pricePending && !checkinPending) {
                setReady(true);
            }
        }
    },[_checkin]);

    useEffect(() => {
        if(_submitCheckin.success === "" || !checkinPending) return;

        if (_submitCheckin.success === true) {
            setCheckIn(_submitCheckin.data.checkins);
            new Notification({
                message : t('saved_${a}',{a:(_submitCheckin.data.checkins.checkout === null?t('checkin_reservation'):t('checkout_reservation'))},'capital'),
                duration : 5000,
                type : 'success',
                closeable : true,
                icon : 'fi fi-mail'
            });
            abort();
        } else {
            if(isStepCheckout) {
                if (_submitCheckin.data.code === 404 || _submitCheckin.data.code === 403) {
                    let bestaetigung = window.confirm('Ein Fehler ist beim Versuch die Zahlung einzuziehen aufgetreten. Wir weisen darauf hin, dass in diesem Fall beim Check-Out der nachzuzahlende Betrag nicht beim Nutzer eingezogen wird. Soll der Check-Out dennoch durchgeführt werden?');
                    if (bestaetigung) {
                        let clone = {...checkIn};
                        clone.bypassPayment = true;
                        let newClone = {id : clone.id,
                            checkout : clone.checkout,
                            location_checkout: clone.location_checkout,
                            resource_id: clone.resource_id,
                            reservation_id: clone.reservation_id,
                            skipFacilitySlotCheck: true,
                            //lat: location.latitude,
                            //lng: location.longitude,
                            comment_checkout : clone.comment_checkout,
                            bypassPayment: true
                        }
                        submit(newClone);
                    }
                }else {
                    new Notification({
                        message: t('checkin_save_error') + " " + (typeof _submitCheckin.data.message !== 'undefined' ? _submitCheckin.data.message : ""),
                        duration: 5000,
                        type: 'error',
                        closeable: true,
                        icon: 'fi fi-mail'
                    });
                }
            } else {
                new Notification({
                    message: t('checkin_save_error') + " " + (typeof _submitCheckin.data.message !== 'undefined' ? _submitCheckin.data.message : ""),
                    duration: 5000,
                    type: 'error',
                    closeable: true,
                    icon: 'fi fi-mail'
                });
            }
        }
        setCheckinPending(false);

    },[_submitCheckin]);


    const initialize = () => {
        if (ready) {
            return;
        }

        if (locationsPending || contingentPending || resourcePending || resourcesPending || pricePending || checkinPending) {
            return;
        }

        if (typeof reservation.checkins === 'undefined' || reservation.checkins.length === 0) {
            setIsStepCheckout(false);
        }

        // get locations and users to filter for
        props.dispatch(locationActions.getLocations({
            token: Biscuit.get('token'),
            filter: {
                findForSelect: true,
                find: 'short',
                limit: 999,
                page: 1
            },
        }));
        setLocationsPending(true);

        if(reservation.contingents.length > 0) {
            let c = reservation.contingents[0];
            setContingent(c);
            if(!isStepCheckout) {
                props.dispatch(resourcesActions.getResources({
                    token: Biscuit.get('token'),
                    filter: {
                        find: '!CheckedIn',
                        contingent_id: c.id,
                        limit: 999
                    },
                }));
            } else {
                props.dispatch(resourcesActions.getResources({
                    token: Biscuit.get('token'),
                    filter: {
                        contingent_id: c.id,
                        limit: 999
                    },
                }));
            }
            setResourcesPending(true);
            // setContingentPending(true);
        }
        if(!multipleCheckins) {
            if (reservation.checkins.length > 0 && typeof reservation.checkins[0] !== 'undefined') {
                props.dispatch(resourcesActions.getResource({
                    token: Biscuit.get('token'),
                    id: ((typeof props.checkin !== 'undefined' && props.checkin !== null) ? props.checkin.resource_id : reservation.checkins[0].resource_id)
                }));
                setResourcePending(true);
            }
            setResourceIdWithAmounts();
        } else {
            reservation.checkins.map(checkin => {
                props.dispatch(resourcesActions.getResource({
                    token: Biscuit.get('token'),
                    id: checkin.resource_id
                }));
            });
            setResourcePending(true);
        }



        // setRequiredContingentsWithAmounts();
        /* let clone = {...counted};
         clone++;
         setCounted(clone);*/


    };


    if (!ready) {
        initialize();
    }

    const location_checkin = checkIn.location_checkin_name;
    const location_checkout = checkIn.location_checkout_name;

    const _changeCheckoutDate = (dates) => {

        let temp = moment(dates);
        const hours = date.hours;
        const minutes = date.minutes;

        temp.set('hours', hours);
        temp.set('minutes', minutes);
        setDate(dates);
        const el = document.getElementById('inb-hidden-checkout-date');
        if (typeof el !== undefined && el !== null) {
            el.value = temp.format('YYYY-MM-DD HH:mm:00');
        }

        getCheckoutPrice();

    };


    const _changeCheckoutTime = (ev) => {

        const values = ev.target.value.split(':');
        if (values.length !== 2) return;
        /* let notComplete = false;
         _.each(values,function(i,v){
             console.log(i);
            if(i.split().length < 2){
                notComplete = true;
                return;
            }
         });
         if(notComplete) return;*/
        let temp = moment(date);
        const hours = ev.target.value.split(':')[0];
        const minutes = ev.target.value.split(':')[1];

        if (isNaN(hours)) return;
        if (isNaN(minutes)) return;

        temp.set('hours', hours);
        temp.set('minutes', minutes);
        setDate(new Date(temp.format('YYYY-MM-DD HH:mm:00')));
        const el = document.getElementById('inb-hidden-checkout-date');
        if (typeof el !== undefined && el !== null) {
            el.value = temp.format('YYYY-MM-DD HH:mm:00');
        }

        getCheckoutPrice();
    };

    const _changeCommentCheckOut = (ev) => {
        const clone = {...checkIn};
        clone.comment_checkout = ev.target.value;
        setCheckIn(clone);
    };

    const _changeCommentCheckIn = (ev) => {
        const clone = {...checkIn};
        clone.comment_checkin = ev.target.value;
        setCheckIn(clone);
    };

    const _cancelOrder = () => {
        props.dispatch(reservationsActions.patchReservations(
            {
                token: Biscuit.get('token'),
                reservation_id: reservation.id,
                data: {
                    status: 'cancelled',
                    id: reservation.id
                }
            }
        ));
        setReservationPending(true);
    };
    const submitCheckins = () => {
        let clone = {...checkIn};
        delete clone.resource;
        delete clone.location_checkin_name;
        delete clone.location_checkout_name;
        if(Object.keys(_checkin.selectedResources).length > 0 && !isStepCheckout){
            if(Object.keys(_checkin.selectedResources).length > 1){
                setMulti(true);
            }
            let now = moment(date).format('YYYY-MM-DD HH:mm:00');
            let count = 1;
            _.each(_checkin.selectedResources,function(resource){
                clone.resource_id = resource.id;
                clone.checkin = now;
                count++;
                if(count === Object.keys(_checkin.selectedResources).length){
                    setMulti(false);
                }
                submit(clone);
            })
        } else {
            submit(clone);
        }
    }

    const submit = (clone) => {
        if(checkinPending && checkIn === clone){
            return;
        }
        if(typeof clone.id === 'undefined'){
            props.dispatch(checkinActions.checkinReservation({
                token: Biscuit.get('token'),
                data: clone
            }));
        } else {
            if(isStepCheckout) {
                if(document.getElementById('inb-hidden-checkout-date') !== null) {
                    clone.checkout = document.getElementById('inb-hidden-checkout-date').value;
                }
                if(locationCheckout === null && clone.location_checkout === null){
                    setLocationCheckout(clone.location_checkin);
                    clone.location_checkout = clone.location_checkin;
                }
            }
            let newClone = {id : clone.id,
                checkout : clone.checkout,
                location_checkout: clone.location_checkout,
                resource_id: clone.resource_id,
                reservation_id: clone.reservation_id,
                skipFacilitySlotCheck: true,
                bypassPayment: clone.bypassPayment,
                //lat: location.latitude,
                //lng: location.longitude,
                comment_checkout : clone.comment_checkout}

            props.dispatch(checkinActions.checkoutReservation({
                token: Biscuit.get('token'),
                checkin_id: newClone.id,
                data: newClone
            }));
        }
        setCheckinPending(true);
        setCheckIn(clone);
    }
    let checkinDate = (reservation.checkins && typeof reservation.checkins[0] !== 'undefined' && typeof reservation.checkins[0].checkin !== 'undefined')?reservation.checkins[0].checkin:null;


    let setTableCSS = {fontWeight: "bold",display: "table",minHeight: "50px",paddingTop: "5px",paddingBottom: "5px"};

    const changeLocation = (e) => {
        setLocationCheckout(e.target.value);
        let clone = {...checkIn};
        clone.location_checkout = e.target.value;
        setCheckIn(clone);
    }

    const abort = (e) => {
        setReady(false);
        props.setFilter(props.filter);
        props.setSort(props.sort);
        props.setNKey(props._key);
        props.setCheckout(false);
        props.filterChangedHandle(props.filter);
        abortButtonRef.current.click();

    }
    const currentUrl = new URL(window.location.href)
    const abortButtonRef = React.createRef();
    let returnUrl = (typeof props.requestPath !== 'undefined') ? props.requestPath + currentUrl.search : (typeof props.returnUrl !== 'undefined' && props.returnUrl !== null) ? props.returnUrl : `/reservations/reservationsList${currentUrl.search}`;
    let checkinCartClass = checkinDate === null?"medium-6":"medium-8";
    let checkoutCompleteClass = checkinDate !== null?"hide":"";
    const retoure = (e) => {
        window.location.replace(returnUrl);
    }
    return (
        <>
            {_checkin !== null && <>
                <div id="inb-checkin" className="medium-12 column">

                    <div id="inb-checkin-header" className="row">
                        <div className="medium-8 column">
                            {checkinDate === null &&
                                <h4>{t('checkin_reservation')}</h4>}
                            {checkinDate !== null &&
                                <h4>{t('checkout_reservation')}</h4>}
                            <p className="checkin-subtitle">
                                {t('reservation')} #
                                {reservation.id},
                                {moment(reservation.begin).format('dd, DD.MM.YY, HH:mm')}
                                - {moment(reservation.end).format('dd, DD.MM.YY, HH:mm')}
                            </p>
                        </div>

                        <div className="medium-4 column text-right">
                            {!checkoutComplete &&
                                <>
                                    {!checkinPending &&
                                        <>
                                            <a id="inb-checkin__submit" href="#"
                                               className={"button beautify " + checkoutCompleteClass}
                                               style={{marginRight: "5px",marginTop: "2px"}} onClick={submitCheckins}>
                                                {checkinDate === null ? t('submit_checkin') : t('submit_checkout')}
                                            </a>
                                        </>
                                    }
                                            {checkinPending &&
                                                <>
                                                    <span><img alt="RollingLoader" className="rollingLoader" src={"assets/img/rolling_loader.svg"} />

                                                        {checkinDate === null ? t('submit_checkin') : t('submit_checkout')}
                                                    </span>
                                        </>
                                    }
                                </>
                            }
                            {props.returnUrl !== null && typeof props.returnUrl !== 'undefined' ?
                                <a
                                    href="#"
                                    ref={abortButtonRef}
                                    className="button-checkin-abort button hollow secondary right button-abort round"
                                    title={t('checkin_out_abort', null, 'capital')}
                                    onClick={(e) => {retoure(e)}}
                                ><i className="fi fi-x"> </i>
                                </a>
                                :
                                <a
                                    href={returnUrl}
                                    ref={abortButtonRef}
                                    className="button-checkin-abort button hollow secondary right button-abort round"
                                    title={t('checkin_out_abort', null, 'capital')} onClick={(e) => {abort(e)}}>
                                    <i className="fi fi-x"> </i>
                                </a>
                            }
                        </div>
                    </div>

                    <div className="row">
                        {checkinDate === null &&
                            <div id="inb-checkin-all-contingents" className="medium-6 column">
                                <h4 style={{paddingLeft: "1rem"}}>
                                    {t('booked', null, 'capital')} {t('contingents')}
                                </h4>

                                <input
                                    type="text"
                                    id="inb-checkin-all-contingents__search"
                                    placeholder={t('checkin_search_placeholder')}
                                />

                                <div className="content">
                                    <CheckInItem
                                        contingent={contingent}
                                        isStepCheckout={isStepCheckout}
                                        selectionIsComplete={selectionIsComplete}
                                        isCartView={isCartView}
                                        checkin={props.checkin}
                                        _checkin={_checkin}
                                        _setCheckin={_setCheckin}
                                        resources={resources}
                                        checkoutComplete={checkoutComplete}
                                        locationsPending={locationsPending}
                                        locations={locations}
                                        locationCheckout={locationCheckout}
                                        setTableCSS={setTableCSS}
                                        date={date}
                                        _changeCheckoutDate={_changeCheckoutDate}
                                        _changeCheckoutTime={_changeCheckoutTime}
                                        _cancelOrder={_cancelOrder}
                                        location_checkin={location_checkin}
                                        reservation={reservation}
                                        selectedResources={selectedResources}
                                        location_checkout={location_checkout}
                                        setForCheckoutExtended={setForCheckoutExtended}
                                        _changeCommentCheckOut={_changeCommentCheckOut}
                                        _changeCommentCheckIn={_changeCommentCheckIn}
                                        checkinPending={checkinPending}
                                        submitCheckins={submitCheckins}
                                    />
                                </div>
                            </div>
                        }

                        <div
                            id="inb-checkin-cart"
                            className={checkinCartClass + " column"}
                            style={(checkinDate !== null ? {margin: "0 auto"} : {})}>
                            <div className="row">
                                <h4 className="medium-6 small-6 column">
                                    {t('checked_in_contingents')}
                                </h4>
                                {checkinDate !== null && checkoutComplete === false &&
                                    <>
                                        <div className="medium-4 small-4 column"
                                             style={{marginTop: "auto", marginBottom: "auto", textAlign: "right"}}>
                                            <span>{t('checkout_price', null, 'capital')}: </span>
                                        </div>
                                        <div className="medium-2 small-2 column"
                                             style={{
                                                 marginTop: "auto",
                                                 marginBottom: "auto",
                                                 paddingRight: "30px",
                                                 paddingLeft: "0px",
                                                 textAlign: "right"
                                             }}>
                                            <span id="inb-checkout-price-value"> </span>
                                        </div>
                                    </>
                                }

                                <div
                                    className="inb-checkin-out-location-wrapper medium-4 medium-offset-1 column hide"
                                    title={t('checkin_out_location')}
                                    style={{marginTop: "1rem"}}>
                                    <select className="inb-checkin-out-location" onChange={(e)=>{changeLocation(e)}}>
                                        {!locationsPending && locations.map(location => {
                                            return (<>
                                                    <option value={location.id}>{location.name}</option></>
                                            );
                                        })}
                                    </select>
                                </div>
                            </div>
                            <div className="row">
                                <div className="medium-5 small-3 column"> </div>
                                <div id="inb-checkout-extension-hint"
                                     className="text-right medium-5 small-7 column hide"
                                     style={{fontSize: "0.8125rem"}}><i className="fi fi-alert"
                                                                        style={{marginRight: "3px"}}> </i><span>
                                {t('checkout_extend_hint')}</span></div>
                                <div className="medium-2 small-2 column text-right hide"
                                     style={{paddingRight: "30px", paddingLeft: "0px", color: "red"}}><span
                                    id="inb-checkout-extra-value"> </span></div>
                            </div>
                            <div className="content">
                                <CheckOutItem
                                    contingent={contingent}
                                    isStepCheckout={isStepCheckout}
                                    selectionIsComplete={selectionIsComplete}
                                    isCartView={isCartView}
                                    checkin={props.checkin}
                                    _checkin={_checkin}
                                    _setCheckin={_setCheckin}
                                    resources={resources}
                                    checkoutComplete={checkoutComplete}
                                    locationsPending={locationsPending}
                                    locations={locations}
                                    locationCheckout={locationCheckout}
                                    setTableCSS={setTableCSS}
                                    date={date}
                                    _changeCheckoutDate={_changeCheckoutDate}
                                    _changeCheckoutTime={_changeCheckoutTime}
                                    _cancelOrder={_cancelOrder}
                                    location_checkin={location_checkin}
                                    reservation={reservation}
                                    selectedResources={selectedResources}
                                    location_checkout={location_checkout}
                                    setForCheckoutExtended={setForCheckoutExtended}
                                    checkIn={checkIn}
                                    setCheckIn={setCheckIn}
                                    _changeCommentCheckOut={_changeCommentCheckOut}
                                    _changeCommentCheckIn={_changeCommentCheckIn}
                                    checkinPending={checkinPending}
                                    submitCheckins={submitCheckins}
                                    multipleCheckins={multipleCheckins}
                                    checkIns={checkIns}
                                    setCheckIns={setCheckIns}
                                    changeLocation={changeLocation}
                                />
                            </div>
                        </div>

                    </div>

                </div>
            </>
            }
        </>
    );
}

export default CheckOutView;